module.exports = __webpack_public_path__ + "img/full0-min.c73b726f.png";